<template>
    <CCol v-bind="$attrs">
        <ValidationProvider tag="div" :vid="vid" :name="name" :rules="rules" v-slot="{ errors }">
        <CSelect
            :disabled="disabled"
            :options="options"
            :value="initialValue"
            @update:value="updateSelectType"
            :description="description"
            :addInputClasses="addInputClasses"
            :addLabelClasses="addLabelClasses"
            :addWrapperClasses="addWrapperClasses"
            :ignoreOptionStyle="ignoreOptionStyle"
        >
            <template #label>
                <slot :name="label">{{ autoLabel }}</slot>
                <span class="text-danger" v-if="required">*</span>
            </template>
            <template #invalid-feedback>
                <span class="invalid-feedback d-block">{{ errors[0] }}</span>
            </template>
            <template v-for="(_, slot) in $slots">
                <template :slot="slot">
                    <slot :name="slot"></slot>
                </template>
            </template>
        </CSelect>
        </ValidationProvider>
    </CCol>
</template>

<script>
import { DefaultSelectProps } from './defaultProps'

export default {
    name: 'CCustomSelect',
    props: {
        ...DefaultSelectProps,
        asInt: {
            default: false,
            type: Boolean,
        },
        addInputClasses: [String, Array, Object],
        addLabelClasses: [String, Array, Object],
		addWrapperClasses: [String, Array, Object],
        ignoreOptionStyle: {
			type: Boolean,
			default: false
		}
    },
    data () {
        return {
            //
        }
    },
    computed: {
        initialValue() {
            return this.value //? this.value.toString() : ''
        },
        autoLabel() {
            return this.label === '' ? this.name : this.label
        }
    },
    methods: {
        updateSelectType(value) {
            this.$emit( 'input', this.asInt ? parseInt( value ) : value )
            this.$emit( 'update', this.asInt ? parseInt( value ) : value )
        }
    },
}
</script>